import React, { useState, useRef } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";

const ViewVideoScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { uri } = location.state || {};
  const [videoUrl, setVideoUrl] = useState(uri);
  const [paused, setPaused] = useState(false);
  const playerRef = useRef(null);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePause = () => {
    setPaused(!paused);
  };

  const handleRecordAgain = () => {
    navigate("/");
  };

  const handleSubmit = () => {
    // Check if video URL is available
    if (videoUrl) {
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = videoUrl;
      link.setAttribute("download", "recorded_video.mp4");
      // Trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up
      // document.body.removeChild(link);
    }
    // Show modal
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container
      style={{
        flex: 1,
        position: "relative",
        paddingTop: isMobile ? "10px" : "20px",
      }}
    >
      <Box textAlign="center" style={{ marginBottom: isMobile ? "10px" : "20px" }}>
        <Typography variant="h6" style={{ fontSize: isMobile ? "1.2rem" : "1.5rem" }}>
          VIEW RECORDED STATEMENT
        </Typography>
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: isMobile ? "10px" : "20px",
        }}
      >
        {videoUrl ? (
          <ReactPlayer
            ref={playerRef}
            url={videoUrl}
            playing={!paused}
            controls
            width={isMobile ? "100%" : "60%"}
            height={isMobile ? "auto" : "60%"}
            onPlay={() => setPaused(false)}
            onPause={handlePause}
            style={{ backgroundColor: "black" }}
          />
        ) : (
          <Typography variant="h6" color="error">
            No video available
          </Typography>
        )}
      </Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: isMobile ? "10px" : "20px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ marginRight: "10px" }}
        >
          Save Video
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleRecordAgain}
        >
          Record Again
        </Button>
      </Box>
      <IconButton
        style={{ position: "absolute", top: isMobile? "0px" : '10px', right: isMobile ? "0px": '10px' }}
        onClick={() => handleRecordAgain()}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Success"}</DialogTitle>
        <DialogContent>
          <Typography id="alert-dialog-description">
            Video Saved and downloaded successfully.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ViewVideoScreen;
